// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__19plP","label":"SetPasswdForm_label__1xpos"};